'use client'

import { Card, EmptyState, Animation } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/shared/i18n'

import { useAsset } from '@marketplace-web/domain/assets'

const ItemPerformanceEmptyState = () => {
  const translate = useTranslate('item_performance.empty_state')
  const asset = useAsset('/assets/animations')

  return (
    <Card>
      <div className="u-ui-padding-vertical-x-large" data-testid="bump-statistic-empty-state">
        <EmptyState
          title={translate('title')}
          body={translate('body')}
          icon={<Animation animationUrl={asset('feedback-empty-state.json')} />}
        />
      </div>
    </Card>
  )
}

export default ItemPerformanceEmptyState
